import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from "react";
import { Runtime, account } from "@silvertours/front-entities";
import { Ui, http } from "@silvertours/front-shared";
import { CheckIcon } from "./LoginForm.styles";
import { useLogin } from "./LoginState";
var LoginError = function(param) {
    var _translations = param.translations, headline = _translations.headline, message = _translations.message, passwordLostHref = _translations.passwordLostHref, passwordLostLabel = _translations.passwordLostLabel, resendConfirmUser = _translations.resendConfirmUser;
    var ref = useLogin(), username = ref.username, type = ref.error;
    var ref1 = useState(false), isSuccessful = ref1[0], setIsSuccessful = ref1[1];
    var formatApiUrl = Runtime.useAccountConfig().formatApiUrl;
    var whitelabel = Runtime.useWhitelabel().whitelabel;
    if (!type) {
        return null;
    }
    if (type === account.LoginError.UnverifiedEmail) {
        var handleClick = function() {
            var _ref = _async_to_generator(function() {
                var res;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                account.resendConfirmUser(formatApiUrl(http.API.accountResendConfirmUser), username !== null && username !== void 0 ? username : "", whitelabel)
                            ];
                        case 1:
                            res = _state.sent();
                            setIsSuccessful(res);
                            return [
                                2
                            ];
                    }
                });
            });
            return function handleClick() {
                return _ref.apply(this, arguments);
            };
        }();
        return /*#__PURE__*/ _jsxs(Ui.Message, {
            headline: headline,
            children: [
                message,
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx(Ui.TextLink, {
                    as: "button",
                    text: resendConfirmUser,
                    onClick: handleClick
                }),
                isSuccessful && /*#__PURE__*/ _jsx(CheckIcon, {})
            ]
        });
    }
    if ([
        account.LoginError.ExpiredPassword,
        account.LoginError.WeakPassword, 
    ].includes(type)) {
        return /*#__PURE__*/ _jsxs(Ui.Message, {
            headline: headline,
            severity: Ui.MessageSeverity.ERROR,
            role: Ui.MessageRole.ALERT,
            children: [
                message,
                " ",
                /*#__PURE__*/ _jsx(Ui.TextLink, {
                    href: passwordLostHref,
                    text: passwordLostLabel
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Ui.Message, {
        severity: Ui.MessageSeverity.ERROR,
        role: Ui.MessageRole.ALERT,
        children: message
    });
};
export { LoginError };
